export class RealEstateHandlerService {
	constructor($http) {
		'ngInject';
		this.$http = $http;
		this.publicRoot = '/public';
		this.privateRoot = '/private';
	}
	getRealEstateDataById(id) {
		return this.$http.get(`${this.publicRoot}/properties/${id}`);
	}
	compare(ids) {
		return this.$http({
			method: 'GET',
			url: `${this.publicRoot}/properties/compare`,
			params: ids
		});
	}
	interest(params) {
		return this.$http({
			method: 'POST',
			url: `${this.publicRoot}/properties/interest`,
			data: params
		});
	}
	getAgent(id) {
		return this.$http.get(`${this.publicRoot}/agents-and-offices/agents/${id}`);
	}
	sendWebWalk(id) {
		return this.$http.post(`${this.publicRoot}/properties/${id}/webseta`);
	}
}
